import { render, staticRenderFns } from "./B2cGoods.vue?vue&type=template&id=78bac5dc&scoped=true&"
import script from "./B2cGoods.vue?vue&type=script&lang=js&"
export * from "./B2cGoods.vue?vue&type=script&lang=js&"
import style0 from "./B2cGoods.vue?vue&type=style&index=0&id=78bac5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bac5dc",
  null
  
)

export default component.exports